import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';
import history from 'src/libs/history';

export type State = {
  loading: boolean;
};

export const adapter = createEntityAdapter<Model.FAQ_CATEGORY>({
  selectId: (model) => model.id,
});

const { reducer, actions } = createSlice({
  name: 'faq_category',
  initialState: adapter.getInitialState<State>({ loading: false }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.FAQ_CATEGORY[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.FAQ_CATEGORY>) {
      adapter.upsertOne(state, action);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    removeEntity(state, action: PayloadAction<string>) {
      adapter.removeOne(state, action.payload);
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.faq_category,
);

export const selectFAQCategory = createSelector(
  (state: RootState) => selector.selectAll(state),
  (state: RootState, pathName?: string) => pathName,
  (categories, pathName) => {
    const pathname = pathName || history.location.pathname;
    const filter_id = pathname.split('/')[2];
    const options =
      categories?.map((c) => ({ text: c.name, value: c.id })) || [];

    return {
      category: categories.find((o) => o.id === filter_id),
      options,
    };
  },
);

export { reducer };
export default actions;
